// @flow
export const stopTouchEvent = (e?: SyntheticEvent<HTMLButtonElement>) =>
  e && e.stopPropagation();
